import type { InstallmentOptionDto } from './dto/models';
import { RestService, Rest } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class PaywayService {
  private restService = inject(RestService);
  apiName = 'Default';
  

  calculateInstallments = (amount: number, cardBrand: string, bin?: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, InstallmentOptionDto[]>({
      method: 'POST',
      url: '/api/app/payway/calculate-installments',
      params: { amount, cardBrand, bin },
    },
    { apiName: this.apiName,...config });
  

  getCoefficients = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, Record<number, number>>({
      method: 'GET',
      url: '/api/app/payway/coefficients',
    },
    { apiName: this.apiName,...config });
}